import { get } from '../request';
import { APP_CONFIG } from '@/config';
import { TenantNetworkListing } from '@/@types/tenantNetwork';

export const getTenantNetworkListing = async (propertyHubId: string): Promise<TenantNetworkListing> => {
  return await get<TenantNetworkListing>(`${APP_CONFIG.tenantNetworkApiUrl}/listings/property-hub/${propertyHubId}`);
};
